export default __webpack_public_path__ + "static/media/send.bfaf2771.svg";